import { Plan } from './objects';

export const TestPlans: Plan[] = [
	{
		id: '10',
		name: 'Ambetter Essential Care 1 (2021) - EPO',
		icon: 'ambetter.png',
		badges: [],
		premium: 111,
		deductible: 8300,
		all_in: 4544,
		pocket_max: 8300,
		network_type: 'EPO',
		metal_tier: 'Bronze',
		prices_bd: {
			doctor_primary_visit: -1,
			doctor_specialist_visit: -1,
			doctor_preventative_visit: 0,

			drugs_generic: 25,
			drugs_brand: -1,
			drugs_non_brand: -1,
			drugs_specialty: -1,

			labs_xrays: -1,
			labs_imaging: -1,
			labs_blood_work: -1,

			hospital_urgent_care: -1,
			hospital_emergency_room: -1,
			hospital_ambulance: -1,
			hospital_stay_facility: -1,
			hospital_stay_physician: -1,
			hospital_outpaintent_facility: -1,
			hospital_outpaintent_physician: -1,
			hospital_rehabilitation: -1,

			mental_outpatient: -1,
			mental_psychiatric: -1,

			pregnancy_baby_care: 0,
			pregnancy_labor: -1,
		},
		prices_ad: {
			doctor_primary_visit: 0,
			doctor_specialist_visit: 0,
			doctor_preventative_visit: 0,

			drugs_generic: 25,
			drugs_brand: 0,
			drugs_non_brand: 0,
			drugs_specialty: 0,

			labs_xrays: 0,
			labs_imaging: 0,
			labs_blood_work: 0,

			hospital_urgent_care: 0,
			hospital_emergency_room: 0,
			hospital_ambulance: 0,
			hospital_stay_facility: 0,
			hospital_stay_physician: 0,
			hospital_outpaintent_facility: 0,
			hospital_outpaintent_physician: 0,
			hospital_rehabilitation: 0,

			mental_outpatient: 0,
			mental_psychiatric: 0,

			pregnancy_baby_care: 0,
			pregnancy_labor: 0,
		},
		preventative_care: [
			{
				name: 'Aspirin use',
				description: `
				Taking low-dose aspirin regularly can lower your risk for heart attack, stroke, and colorectal cancer. Ask your doctor about taking aspirin regularly if you have any of these risk factors for heart disease: smoking, high blood pressure, high cholesterol, or diabetes.
				<br>
				This service is available if you're aged 50–59 with a high cardiovascular risk, or if you're a woman aged 12–59 who is pregnant and has high blood pressure.`,
				learn_more: undefined,
			},
		],
	},
	{
		id: '20',
		name: 'Oscar Bronze Simple ($3 Prescription List + Free 24/7 Virtual Visits + Free Personal Care Team) - EPO',
		icon: 'oscar.png',
		badges: ['expanded bronze'],
		premium: 272,
		deductible: 7300,
		all_in: 67,
		pocket_max: 8550,
		network_type: 'EPO',
		metal_tier: 'Bronze',
		prices_bd: {
			doctor_primary_visit: -1,
			doctor_specialist_visit: -1,
			doctor_preventative_visit: 0,

			drugs_generic: 3,
			drugs_brand: -1,
			drugs_non_brand: -1,
			drugs_specialty: -1,

			labs_xrays: -1,
			labs_imaging: -1,
			labs_blood_work: -1,

			hospital_urgent_care: 75,
			hospital_emergency_room: -1,
			hospital_ambulance: -1,
			hospital_stay_facility: -1,
			hospital_stay_physician: -1,
			hospital_outpaintent_facility: -1,
			hospital_outpaintent_physician: -1,
			hospital_rehabilitation: -1,

			mental_outpatient: -1,
			mental_psychiatric: -1,

			pregnancy_baby_care: 0,
			pregnancy_labor: -1,
		},
		prices_ad: {
			doctor_primary_visit: -30,
			doctor_specialist_visit: -30,
			doctor_preventative_visit: 0,

			drugs_generic: 3,
			drugs_brand: -30,
			drugs_non_brand: -30,
			drugs_specialty: -30,

			labs_xrays: -30,
			labs_imaging: -30,
			labs_blood_work: -30,

			hospital_urgent_care: 75,
			hospital_emergency_room: -30,
			hospital_ambulance: -30,
			hospital_stay_facility: -30,
			hospital_stay_physician: -30,
			hospital_outpaintent_facility: -30,
			hospital_outpaintent_physician: -30,
			hospital_rehabilitation: -30,

			mental_outpatient: -30,
			mental_psychiatric: -30,

			pregnancy_baby_care: 0,
			pregnancy_labor: -30,
		},
		preventative_care: [
			{
				name: 'Aspirin use',
				description: `
				Taking low-dose aspirin regularly can lower your risk for heart attack, stroke, and colorectal cancer. Ask your doctor about taking aspirin regularly if you have any of these risk factors for heart disease: smoking, high blood pressure, high cholesterol, or diabetes.
				<br>
				This service is available if you're aged 50–59 with a high cardiovascular risk, or if you're a woman aged 12–59 who is pregnant and has high blood pressure.`,
				learn_more: undefined,
			},
		],
	},
];
